import type { VerificationProgress } from '../lib/verifier.js';

const stages: VerificationProgress['stage'][] = ['validating', 'credentials', 'normalizing'];

export function ProcessingView({ progress, previewUrl }: { progress: VerificationProgress; previewUrl?: string | undefined }) {
  const activeIndex = stages.indexOf(progress.stage);
  return (
    <section className="processing-view" aria-live="polite" aria-busy="true">
      <div className="processing-view__visual">
        {previewUrl && <img src={previewUrl} alt="Image being inspected" />}
        <span className="scan-line" aria-hidden="true" />
        <span className="processing-view__grid" aria-hidden="true" />
      </div>
      <div className="processing-view__content">
        <span className="eyebrow">Local inspection in progress</span>
        <h1>Reading the evidence inside your image.</h1>
        <p>{progress.label}</p>
        <ol className="progress-list">
          {stages.map((stage, index) => (
            <li key={stage} className={index < activeIndex ? 'is-complete' : index === activeIndex ? 'is-active' : ''}>
              <span>{index + 1}</span>
              {stage === 'validating' ? 'File safety' : stage === 'credentials' ? 'Content Credentials' : 'Evidence report'}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
